<template>
  <div class="box12">
    <div class="btn" @click="zixun('查看全部')">查看全部</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    zixun(name) {
      this.mai("产品经理-就业课","查看全部",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  width: 100%;
  background: url("../../../assets/coursePage/pm/box12/bgc.png") no-repeat;
  background-size: cover;
  height: 280px;
  box-sizing: border-box;
  overflow: hidden;
  .btn {
    width: 240px;
    height: 72px;
    background-color: #ffffff;
    border-radius: 40px;
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 72px;
    text-align: center;
    letter-spacing: 0px;
    color: #443eff;
    margin: 160px auto 0;
    font-weight: bold;
  }
}
</style>
